<template>
  <div>

    <v-tabs-items v-model="getCurrentTicketTab">
      <v-tab-item>
        <PropsPage/>
      </v-tab-item>

      <v-tab-item>
        <AppSettings/>
      </v-tab-item>

      <v-tab-item>
        <AccountSettings/>
      </v-tab-item>

    </v-tabs-items>

  </div>
</template>

<script>
// import { mapActions } from "vuex"
// import { eventBus } from "@/main"

import {mapGetters} from "vuex";
import PropsPage from "@/components/profile/ProfileCompany.vue";
import AppSettings from "@/components/profile/AppSettings.vue";
import AccountSettings from "@/components/profile/AccountSettings.vue";
export default {
  name: "ProfilePage",
  components: {AccountSettings, AppSettings, PropsPage},
  data() {
    return {
    }
  },
  methods: {
    // ...mapActions("app", ["apiPutFile", "apiGetFile"]),
  },
  watch: {},
  computed: {
    ...mapGetters('app',["getCurrentTicketTab"]),
  },
  created() {},
}
</script>
